import '../styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { Alternatives } from 'components/SmartChatView/Fields'
import AlternativesModal from '../../AlternativesModal'
import ReactTooltip from 'react-tooltip'
import { getStaticImage } from 'utils/statics'

const AlternativesViewUI = ({ id, renderType, label, value, alternativesId, fromAlternativesId, previewActionRef, isOpenAlternativesModal, toggleAlternativesModal, error }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <Alternatives
        isRequired
        label={label}
        value={value}
        fromAlternativesId={fromAlternativesId}
        error={error}
      />
    )}
    {renderType === 'preview' && (
      <div className='action-view__alternatives-preview'>
        <div className='action-view__alternatives-preview-header'>
          <strong className='text-ellipsis'>{value?.questionText}</strong>
          <button onClick={toggleAlternativesModal}>
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-settings.svg')} alt='Configuration'/>
            </figure>
          </button>
        </div>
        {value?.alternativeList && (
          <ol className='action-view__alternatives-preview-list'>
            {value.alternativeList.map((alternative, index) => (
              <li key={index}>
                <p className='text-ellipsis'>{alternative.alternativeText}</p>
              </li>
            ))}
          </ol>
        )}
        {value?.level && (
          <div className='action-view__alternatives-preview-level' data-for={`alternatives-level-tooltip-${id}`} data-tip={I18n.t('smartchat_tooltip_alternativesLevels')}>
            <strong>{value.level}</strong>
            <ReactTooltip id={`alternatives-level-tooltip-${id}`} effect='solid' html={true} />
          </div>
        )}

        {isOpenAlternativesModal && alternativesId && (
          <AlternativesModal
            isOpen={isOpenAlternativesModal}
            toggle={toggleAlternativesModal}
            alternativesId={alternativesId}
            fromAlternativesId={fromAlternativesId}
            previewActionRef={previewActionRef}
          />
        )}
      </div>
    )}
  </div>
)

export default AlternativesViewUI
